import css from './resultPane.module.scss';

import { memo, useCallback } from 'react';

import Button from 'core/ui/Button';
import KeyBind from 'core/ui/KeyBind';

type TProps = {
  disabled: boolean;
  goNext: () => void;
  isLast: boolean;
  className?: string;
};

const ResultBeforePane: React.FC<TProps> = ({
  disabled,
  goNext,
  isLast,
  className = '',
}) => {
  const doFlip = useCallback(() => {
    goNext();
  }, [goNext]);

  return (
    <div className={`${css.resultPane} ${className}`} data-before>
      <KeyBind kkb="ArrowRight" onKeyUp={doFlip} disabled={disabled} />
      <Button
        className={css.action}
        children={isLast ? 'Skip and finish, →' : 'Skip the word, →'}
        onClick={doFlip}
        disabled={disabled}
      />
    </div>
  );
};

export default memo(ResultBeforePane);
